import React, { createContext, useContext, useState } from 'react';
import ModalComponent from './ModalComponent';

// Create a context for the transaction
const TransactionContext = createContext();

// Custom hook to use the transaction context
export const useTransaction = () => useContext(TransactionContext);

// Transaction provider component
export const TransactionProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalProductId, setModalProductId] = useState(null);
  const [modalQuantity, setModalQuantity] = useState(null);


  console.log(modalOpen);

  // Function to add a product to the transaction
  const addProduct = (product) => {
    setProducts([...products, { ...product, quantity: 1 }]);
  };

  // Function to remove a product from the transaction
  const removeProduct = (productId) => {
    setProducts(products.filter((product) => product.id !== productId));
  };

  // Function to update product quantity
  const updateQuantity = (productId, quantity) => {
    const productToUpdate = products.find((product) => product.id === productId);
    if (productToUpdate.balanceQuantity >= quantity) {
      setProducts(
        products.map((product) =>
          product.id === productId ? { ...product, quantity } : product
        )
      );
    } else {
        console.log("Product quantity exceeds balance quantity");
      // Trigger custom permission modal
      openPermissionModal(productId, quantity);
    }
  };

  // Calculate line amount for a product
  const calculateLineAmount = (product) => {
    return product.price * product.quantity;
  };

  // Calculate total amount
  const calculateTotal = () => {
    return products.reduce(
      (total, product) => total + calculateLineAmount(product),
      0
    );
  };

  // Function to open custom permission modal
  const openPermissionModal = (productId, quantity) => {
    setModalOpen(true);
    setModalProductId(productId);
    setModalQuantity(quantity);
  };

  // Function to handle modal confirmation
  const handleModalConfirm = () => {
    // Implement your custom authorization logic here
    const isAuthorized = true; // For demo, always authorize
    if (isAuthorized) {
      setProducts(
        products.map((product) =>
          product.id === modalProductId ? { ...product, quantity: modalQuantity } : product
        )
      );
    }
    // Close modal after confirmation
    setModalOpen(false);
  };

  // Function to handle modal cancellation
  const handleModalCancel = () => {
    // Close modal without updating quantity
    setModalOpen(false);
  };

  return (
    <TransactionContext.Provider
      value={{ products, addProduct, removeProduct, updateQuantity, calculateTotal }}
    >
      {children}
      {modalOpen && <ModalComponent handleModalConfirm={handleModalConfirm} handleModalCancel={handleModalCancel} />}
    </TransactionContext.Provider>
  );
};

// Product List Component
export const ProductListComponent = () => {
  const { products, updateQuantity } = useTransaction();

  return (
    <div>
      <h2>Product List</h2>
      <ul>
        {products.map((product) => (
          <li key={product.id}>
            {product.name} - Quantity:
            <input
              type="number"
              value={product.quantity}
              onChange={(e) => updateQuantity(product.id, parseInt(e.target.value))}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

// Total Amount Component
export const TotalAmountComponent = () => {
  const { calculateTotal } = useTransaction();

  return (
    <div>
      <h2>Total Amount</h2>
      <p>Total: {calculateTotal()}</p>
    </div>
  );
};
